import { PageInfo } from '../commonResponse';
import { OtherAttachDto, PensionType } from '../pensionermanagement/Pensioner';

export class VerificationList {
  Address: string = '';
  ChangeRemark: string = '';
  DateOfBirth: string = '';
  DecisionBy: string = '';
  DecisionReason: string = '';
  DepartmentEntryDate: string = '';
  DepartmentEntryNo: string = '';
  DepartmentName: string = '';
  DepartmentOutputDate: string = '';
  DivisionCode: string = '';
  EmergencyMobileNumber: string = '';
  EnrollmentStatus: string = '';
  FinancialYear: string = '';
  Id: string = '';
  LinkedPPA: string[] = [];
  LiveVerificationAt: string = '';
  LiveVerificationExpireAt: string = '';
  LiveVerificationStatus: string = '';
  MinistryName: string = '';
  MobileNoVerified: string = '';
  MobileNumber: string = '';
  NRC: string = '';
  PPANumber: string = '';
  PensionType: string = '';
  PensionerName: string = '';
  Position: string = '';
  ProjectEntryNo: string = '';
  RegisteredDate: string = '';
  RetakeAssign: string = '';
  SalaryRate: string = '';
  Status: string = '';
  TownshipCode: string = '';
  UploadedFOS: string = '';
}

export class VerificationListPayload {
  CurrentPageNumber: string = '';
  FilterStatus: string = '';
  MobileNumber: string = '';
  NRC: string = '';
  PPANumber: string = '';
  PageSize: string = '';
  RegisterDateFrom: string = '';
  RegisterDateTo: string = '';
  Status: string = '';
  UserName: string = '';
}

export class VerificationListResponse {
  PageInfo!: PageInfo;
  Pensioners: VerificationList[] = [];
}

export type NRCType = 'NewNRC' | 'OldNRC';
export class NRCInfo {
  // Later move to under common.model.ts and remove old obj
  NRCDivisionCodeEN: string = '';
  NRCDivisionCodeMM: string = '';
  NRCTownshipCodeEN: string = '';
  NRCDivisionCode: string = '';
  NRCTownshipCode: string = '';
  NRCTownshipCodeMM: string = '';
  NRCNationality: string = '';
  NRCNationalityMM: string = '';
  NRCSerialNumber: string = '';
  NRCSerialNumberMM: string = '';
  NRCNumber: string = '';
  NRCOldOrNew: NRCType = 'NewNRC';
}
export class PPAInfo {
  // This Object Already Exit.
  // Later move to under common.model.ts and remove old obj
  DataFileld1: string = '';
  DataFileld2: string = '';
  DataFileld3: string = '';
  DataFileld4: string = '';
  DataFileld5: string = '';
  PPANoType: PensionType = 'other';
  PPANumber: string = '';
  PPAOldOrNew: string = '';
}

export class PensionerInfo {
  Id: string = '';
  PensionerName: string = '';
  NRCInfo: NRCInfo = new NRCInfo();
  // NewOrOldNRC: string = '';
  // NRCNo: string = '';
  // PersonalNrcStateCode: string = '';
  // PersonalNrcTownshipCode: string = '';
  // PersonalNrcType: string = '';
  // PersonalNrcSerialNo: string = '';
  DateOfBirth: string = '';
  Age: string = '';
  Gender: string = '';
  Height: string = '';
  ProminentMark: string = '';
  Race: string = '';
  Religion: string = '';
  FatherName: string = '';
  MotherName: string = '';
  DivisionCode: string = '';
  TownshipCode: string = '';
  Address: string = '';
  Remark: string = '';
}

export class EmploymentInfo {
  MilitaryIdNumber: string = '';
  MilitaryId: string = '';
  Position: string = '';
  PositionType: string = '';
  MinistryName: string = '';
  MinistryId: string = '';
  DepartmentName: string = '';
  DepartmentId: string = '';
  TotalServiceYear: string = '';
  DepartmentEntryNo: string = '';
  DepartmentEntryDate: string = '';
  DepartmentOutputNo: string = '';
  DepartmentOutputDate: string = '';
  DepartmentOtherName: string = '';
  ServiceNo: string = '';
}

export class PensionInfo {
  ReligionId: string = '';
  AssignmentDate: string = '';
  EndFinancialYear: string = '';
  ExpiryDateOfFamilyPension: string = '';
  FinancialYear: string = '';
  PPAInfo: PPAInfo = new PPAInfo();
  PensionCommencementDate: string = '';
  PensionWithdrawalBank: string = '';
  ProjectEntryDate: string = '';
  ProjectEntryNo: string = '';
  RelationWithPensioner: string = '';
  SerialNo: string = '';
  StartFinancialYear: string = '';
  TypeOfPension: string = '';
  PensionGroup: string = '';
  PensionGroupId: string = '';
  PensionerName: string = '';
  NRCInfo: NRCInfo = new NRCInfo(); 
  DateOfBirth: string = '';
  FatherName: string = '';
  Age: string = '';
  Remark: string = '';
  Address: string = '';
  TownshipCode: string = '';
  DivisionCode: string = '';
  MotherName: string = '';
  Religion: string = '';
  Race: string = '';
  ProminentMark: string = '';
  Height: string = '';
  Gender: string = '';
  UIDNo: string = '';
  EPensionCardNo: string = '';
}

export class SalaryInfo {
  SalaryRate: string = '';
  LastIssuedSalary: string = '';
  PensionAllowance: string = '';
  GratuityAllowance: string = '';
  ExpenseChildExpense: string = '';
  ExpenseEducationExpense: string = '';
  ExpenseHousing: string = '';
  Bonus: string = '';
  Allowance: string = '';
  OtherAllowance: string = '';
  MEBSalaryRate: string = '';
  MEBLastIssuedSalary: string = '';
  MEBPensionAllowance: string = '';
  MEBGratuityAllowance: string = '';
  MEBOtherAllowance: string = '';
  MEBTransLastDate: string = '';
  AvailableAmount: string = '';
  LastCashoutDate: string = '';
}

export class DeceasedPensionInfo {
  SerialNoOfFamily: string = '';
  ProjectEntryNoOfFamily: string = '';
  ProjectEntryDateOfFamily: string = '';
  PPAInfoOfFamily: PPAInfo = new PPAInfo();
  PPANumberOfFamily: string = '';
  StartFinancialYearOfFamily: string = '';
  EndFinancialYearOfFamily: string = '';
  TypeOfPensionOfFamily: string = '';
  AssignmentDateOfFamily: string = '';
  PensionCommencementDateOfFamily: string = '';
  PensionWithdrawalBankOfFamily: string = '';
  DateOfDeadPensionerOfFamily: string = '';
  PensionGroupOfFamily: string = '';
}

export class DeceasedUserInfo {
  Id: string = '';
  NameOfFamilyPensioner: string = '';
  NRCOfFamilyPensioner: string = '';
  DobOfFamilyPensioner: string = '';
  AgeOfFamilyPensioner: string = '';
  GenderOfFamilyPensioner: string = '';
  HeightOfFamilyPensioner: string = '';
  RaceOfFamilyPensioner: string = '';
  ReligionOfFamilyPensioner: string = '';
  FatherNameOfFamilyPensioner: string = '';
  MotherNameOfFamilyPensioner: string = '';
  DivisionCodeOfFamilyPension: string = '';
  TownshipCodeOfFamilyPension: string = '';
  AddressOfFamilyPension: string = '';
  RemarkOfFamilyPension: string = '';
}

export class DeceasedEmploymentInfo {
  MilitaryIdNumberOfFamily: string = '';
  PositionOfFamily: string = '';
  MinistryOfFamily: string = '';
  DepartmentOfFamily: string = '';
  TotalServiceYearOfFamily: string = '';
  DepartmentEntryNoOfFamily: string = '';
  DepartmentEntryDateOfFamily: string = '';
  DepartmentOutputNoOfFamily: string = '';
  DepartmentOutputDateOfFamily: string = '';
}
export class DeceasedSalaryInfo {
  SalaryOfFamilyPension: string = '';
  SalaryRateOfFamilyPension: string = '';
  LastIssuedSalaryOfFamilyPension: string = '';
  PensionAllowanceOfFamilyPension: string = '';
  GratuityAllowanceOfFamilyPension: string = '';
}
export class BeneficiaryInfo {
  NameOfBeneficiaryPensioner: string = '';
  NRCOfBeneficiaryPensioner: string = '';
  FatherNameOfBeneficiaryPensioner: string = '';
  DOBOfBeneficiaryPensioner: string = '';
  AgeOfBeneficiaryPensioner: string = ''; // DetailResponse မှာမပါလာပါ။
  RelationOfBeneficiaryPensioner: string = '';
}
export class OfficerInfo {
  Status: string = '';
  IsChecked: '0' | '1' = '0'; // L1 Officer Check
  IsDataFound: 'true' | 'false' = 'false'; //isImportPension
  IsMatched: string = '';
  L1DecisionReasion: string = '';
  L1DecisionReasionAt: string = '';
  L1DecisionReasionBy: string = '';
  L2DecisionReasion: string = '';
  L2DecisionReasionAt: string = '';
  L2DecisionReasionBy: string = '';
  PDL1DecisionReasion: string = '';
  PDL1DecisionReasionAt: string = '';
  PDL1DecisionReasionBy: string = '';
  PDL2DecisionReasion: string = '';
  PDL2DecisionReasionAt: string = '';
  PDL2DecisionReasionBy: string = '';
}
export class OtherInfo {
  IsEPension!: string;
  EPensionCardBack: string = '';
  EPensionCardFront: string = '';
  PensionBookPage1: string = '';
  PensionBookPage2: string = '';
  PensionBookPage3: string = '';
  OtherAttachments: any[] = [];

  IsFamilyPension: 'true' | 'false' = 'false';
  IsOpen: string = '';
}
export class PeymeUserVerification<T> {
  Address: string = '';
  DateOfBirthFormatted: string = '';
  DateOfBirdth: string = '';
  DecisionReasion: string = '';
  DivisionId: string = '';
  EmergencyMobileNumber: string = '';
  FaceVerifiedAtFormatted: string = '';
  FatherName: string = '';
  FullName: string = '';
  PensionerName: string = '';
  GuardianId: string = '';
  GuardianName: string = '';
  Id: string = '';
  L1DecisionReason: string = '';
  L1DecisionReasonAt: string = '';
  L1DecisionReasonBy: string = '';
  L2DecisionReason: string = '';
  L2DecisionReasonAt: string = '';
  L2DecisionReasonBy: string = '';
  MobileNoVerified: 'Yes' | 'No' = 'No';
  MobileNumber: string = '';
  NRCBack: string = '';
  NRCBackLoading: string = '';
  NRCFront: string = '';
  NRCFrontLoading: string = '';
  NRC: string = '';
  NRCMM: string = '';
  NRCType: string = '';
  NRCDivisionCodeEN: string = '';
  NRCNationality: string = '';
  NRCSerialNumber: string = '';
  NRCTownshipCodeEN: string = '';
  Pensions: any[] = [];
  PensionRegistrationDetails: any[] = [];
  ReasonForNoNRC: string = '';
  RelationEmergencyContact: string = '';
  RelationshipId: string = '';
  Status: string = '';
  TownshipId: string = '';
  TownshipName: string = '';
  DivisionName: string = '';
  VerificationVideo: string = '';
  IsSuccessLiveness:string = '';
  LivenessFailedMessage:string = '';
  UIDNo:string = '';
  NRCInfo: NRCInfo = new NRCInfo(); // For Data Dto
  isDisabled: boolean = true; // For Data Dto
  IsSuccessLivenessImage: string = '';
  LivenessImageFailedMessage: string = '';
  IsSuccessLivenessVideo: string = '';
  LivenessVideoFailedMessage: string = '';
  IsCashoutPayMe: boolean = true;
  CashoutSource: string = '';
  NomineeInfo : NomineeObj = new NomineeObj();
  IsOpenPinSinPay!: boolean;
}

export enum UserAction {
  L1Approve = 'l1approve',
  L2Approve = 'l2approve',
  L1Reject = 'l1reject',
  L2Reject = 'l2reject',
  PDL1Approve = 'pdl1approve',
  PDL2Approve = 'pdl2approve',
  PDL1Reject = 'pdl1reject',
  PDL2Reject = 'pdl2reject',
  PDReject = 'pdreject'
}

export class NomineeObj{
  Id!: string;
  Name!: string;
  NRCDivisionCode!: string;
  NRCTownshipCode!: string;
  NRCNationality!: string;
  NRCSerialNumber!: string;
  NRC!: string;
  NRCType!: string;
  DateOfBirth!: string;
  MobileNumber!: string;
  Address!: string;
  Relation!: string;
  RelationId!: string;
  NRCInfo : NRCInfo = new NRCInfo();
}

export class PaymePensionVerification {
  // Delete When Pension Info Finsih
  EndFinancialYear: string = '';
  StartFinancialYear: string = '';
  PensionGroup: string = ''; // later add to pension info

  // Delete pensionerInfo Finish
  PensionerName: string = '';
  NewOrOldNRC: NRCType = 'NewNRC';
  NRCNo: string = '';
  PersonalNrcStateCode: string = '';
  PersonalNrcTownshipCode: string = '';
  PersonalNrcType: string = '';
  PersonalNrcSerialNo: string = '';
  DateOfBirth: string = '';
  Age: string = '';
  Gender: string = '';
  Height: string = '';
  ProminentMark: string = '';
  Race: string = '';
  Religion: string = '';
  FatherName: string = '';
  MotherName: string = '';
  DivisionCode: string = '';
  TownshipCode: string = '';
  Address: string = '';
  Remark: string = '';

  // Delete employmentInfo Finish
  MilitaryIdNumber: string = '';
  Position: string = '';
  MinistryName: string = '';
  DepartmentName: string = '';
  TotalServiceYear: string = '';
  DepartmentEntryNo: string = '';
  DepartmentEntryDate: string = '';
  DepartmentOutputNo: string = '';
  DepartmentOutputDate: string = '';

  // Delete salary info finish
  SalaryRate: string = '';
  LastIssuedSalary: string = '';
  PensionAllowance: string = '';
  GratuityAllowance: string = '';
  ExpenseChildExpense: string = '';
  ExpenseEducationExpense: string = '';
  ExpenseHousing: string = '';
  Bonus: string = '';
  Allowance: string = '';

  // Delete Deceased Pension info finish
  SerialNoOfFamily: string = '';
  ProjectEntryNoOfFamily: string = '';
  ProjectEntryDateOfFamily: string = '';
  PPANumberOfFamily: string = '';
  StartFinancialYearOfFamily: string = '';
  EndFinancialYearOfFamily: string = '';
  TypeOfPensionOfFamily: string = '';
  AssignmentDateOfFamily: string = '';
  PensionCommencementDateOfFamily: string = '';
  PensionWithdrawalBankOfFamily: string = '';
  DateOfDeadPensionerOfFamily: string = '';
  PensionGroupOfFamily: string = '';

  // Delete Deceased User info finish
  Id: string = '';
  NameOfFamilyPensioner: string = '';
  NRCOfFamilyPensioner: string = '';
  DobOfFamilyPensioner: string = '';
  AgeOfFamilyPensioner: string = '';
  GenderOfFamilyPensioner: string = '';
  HeightOfFamilyPensioner: string = '';
  RaceOfFamilyPensioner: string = '';
  ReligionOfFamilyPensioner: string = '';
  FatherNameOfFamilyPensioner: string = '';
  MotherNameOfFamilyPensioner: string = '';
  DivisionCodeOfFamilyPension: string = '';
  TownshipCodeOfFamilyPension: string = '';
  AddressOfFamilyPension: string = '';
  RemarkOfFamilyPension: string = '';

  // Delete Deceased Empoyment info finish
  MilitaryIdNumberOfFamily: string = '';
  PositionOfFamily: string = '';
  MinistryOfFamily: string = '';
  DepartmentOfFamily: string = '';
  TotalServiceYearOfFamily: string = '';
  DepartmentEntryNoOfFamily: string = '';
  DepartmentEntryDateOfFamily: string = '';
  DepartmentOutputNoOfFamily: string = '';
  DepartmentOutputDateOfFamily: string = '';

  // Delete Deceased Salary info finish
  SalaryOfFamilyPension: string = '';
  LastIssuedSalaryOfFamilyPension: string = '';
  PensionAllowanceOfFamilyPension: string = '';
  GratuityAllowanceOfFamilyPension: string = '';

  // Delete Beneficiary info finish
  NameOfBeneficiaryPensioner: string = '';
  NRCOfBeneficiaryPensioner: string = '';
  FatherNameOfBeneficiaryPensioner: string = '';
  DOBOfBeneficiaryPensioner: string = '';
  RelationOfBeneficiaryPensioner: string = '';

  // Delete Remart Info Finish
  L1DecisionReasion: string = '';
  L1DecisionReasionAt: string = '';
  L1DecisionReasionBy: string = '';
  L2DecisionReasion: string = '';
  L2DecisionReasionAt: string = '';
  L2DecisionReasionBy: string = '';
  PDL1DecisionReasion: string = '';
  PDL1DecisionReasionAt: string = '';
  PDL1DecisionReasionBy: string = '';
  PDL2DecisionReasion: string = '';
  PDL2DecisionReasionAt: string = '';
  PDL2DecisionReasionBy: string = '';

  IsEPension!: boolean;
  EPensionCardBack: string = '';
  EPensionCardFront: string = '';
  PensionBookPage1: string = '';
  PensionBookPage2: string = '';
  PensionBookPage3: string = '';
  OtherAttachments: OtherAttachDto[] = [];

  IsChecked: string = ''; // L1 Officer Check
  IsDataFound: 'true' | 'false' = 'false'; //isImportPension
  IsMatched: string = '';
  IsFamilyPension: string = '';
  IsOpen: string = '';
  CalledBackEnd: string = '';
  PensionInfo: PensionInfo = new PensionInfo();
  Status: string = '';

  // No Need
  EPensionCardBackLoading: string = '';
  EPensionCardFrontLoading: string = '';
  PensionBookPage1Loading: string = '';
  PensionBookPage2Loading: string = '';
  PensionBookPage3Loading: string = '';
  DateOfDeadPensioner: string = '';
  DecisionReasion: string = '';
  Division: string = '';
  Township: string = '';
  PrimaryPensionerDateOfDead: string = '';
  Personalnumber: string = '';
  PensionImportedId: string = '';
  ExpenseChildSupport: string = '';
  NRCTownshipCodeList: string = '';
  FamilyPensionCommencementDate: string = '';
}

export class VerificationDetailPayload {
  FilterStatus: string = '';
  PensionerRegistrationId: string = '';
}

export class VerificationDetailResponse {
  PaymeUser: PeymeUserVerification<PaymePensionVerification> =
    new PeymeUserVerification();
}

class ApprovedPensionBasePayLoad {
  PensionId: string = '';
  DecisionReason: string = '';
}
export class ApprovedPensionL1PayLoad extends ApprovedPensionBasePayLoad {
  IsChecked: string = '';
  IsMatched: string = '';
}
export class ApprovedPensionL2PayLoad extends ApprovedPensionBasePayLoad {
  IsMatched: string = '';
}
export class ApprovedPensionPDPayLoad extends ApprovedPensionBasePayLoad {
  SalaryRate: string = '';
  LastIssuedSalary: string = '';
  PensionAllowance: string = '';
  GratuityAllowance: string = '';
}
export type VerificationPensionPayloadType =
  | ApprovedPensionBasePayLoad
  | ApprovedPensionL1PayLoad
  | ApprovedPensionPDPayLoad;
